import createAPIServices from './createAPIServices'

const api = createAPIServices()

// api medias
export const getListMediaQueryById = lst => {
    return api.makeAuthRequest({
        url: `/media/query/list?ids=${lst}`,
        method: 'GET',
    })
}

export const getListMedias = (page_number = 1, page_size = 10, status = 0, textsearch = "", begin_time = 0, end_time = 0, type_search = '') => {
    if (textsearch.trim() === "" && begin_time == 0 && end_time == 0 && type_search == 0)
        return api.makeAuthRequest({
            url: `/media?page_number=${page_number}&page_size=${page_size}&deleted=${status}`,
            method: 'GET'
        })

    return api.makeAuthRequest({
        url: `/search/medias_v2`,
        method: 'POST',
        data: {
            "type_search": type_search,
            "text_search": textsearch,
            "page_number": page_number,
            "page_size": page_size,
            "status": status,
            "begin_time": begin_time,
            "end_time": end_time

        }
    })
}

export const createMedia = qbmedia => {
    const json = JSON.stringify(qbmedia)

    return api.makeAuthRequest({
        url: `/media`,
        method: 'POST',
        data: json,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export const getMediaById = mid => {
    return api.makeAuthRequest({
        url: `/media/${mid}`,
        method: 'GET',
    })
}

export const updateMediaById = (mid, qbmedia) => {
    const json = JSON.stringify(qbmedia)

    return api.makeAuthRequest({
        url: `/media/${mid}`,
        method: 'PUT',
        data: json,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export const deleteMedia = mid => {
    return api.makeAuthRequest({
        url: `/media/${mid}`,
        method: 'DELETE',
    })
}


export const getRelateMediaApi = mid => {
    return api.makeAuthRequest({
        url: `/media/${mid}/ext`,
        method: 'GET',
    })
}

export const uploadMediaFile = file => {
    const formData = new FormData()
    formData.append('files', file)

    const uploadAPI = createAPIServices({
        // BaseURL: 'http://10.10.0.15:82',
        BaseURL: 'https://upload.mediacloud.mobilelab.vn',
    })

    return uploadAPI.makeRequest({
        url: '/upload',
        method: 'POST',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
